import type { ReactNode } from 'react';
import { isIndependenceWindow } from '@/utils/festive';

/**
 * Wraps a circular avatar with a subtle Indian-flag tricolor ring during the
 * Independence Day window (14–16 Aug IST). Outside the window it renders its
 * children unchanged, so callers can wrap unconditionally.
 */
export function TricolorRing({
  children,
  ring = 2.5,
  gap = 1.5,
  gapColor = '#fff',
}: {
  children: ReactNode;
  ring?: number;
  gap?: number;
  gapColor?: string;
}): JSX.Element {
  if (!isIndependenceWindow()) return <>{children}</>;
  return (
    <span
      style={{
        display: 'inline-flex',
        borderRadius: '50%',
        padding: ring,
        background:
          'linear-gradient(180deg, #FF9933 0%, #FF9933 34%, #FFFFFF 34%, #FFFFFF 66%, #138808 66%, #138808 100%)',
      }}
    >
      <span
        style={{ display: 'inline-flex', borderRadius: '50%', padding: gap, background: gapColor }}
      >
        {children}
      </span>
    </span>
  );
}
